const images: NodeListOf<HTMLElement> = document.querySelectorAll<HTMLElement>(
	'.block-image-card-gallery__image'
);
const mainImage: HTMLImageElement =
	document.querySelector<HTMLImageElement>('.block-image-card-gallery__main-image img') ??
	document.createElement('img');

function handleImageClick(e: MouseEvent): void {
	const el = e.target as HTMLElement;
	const src: string | null = el.getAttribute('src');
	if (src) {
		mainImage.src = src;
	}

	images.forEach((image) => {
		image.classList.remove('block-image-card-gallery__image--selected');
	});

	el.closest('.block-image-card-gallery__image')?.classList.add(
		'block-image-card-gallery__image--selected'
	);
}

images.forEach((image) => {
	image.addEventListener('click', handleImageClick);
});
